<template>
  <div class="absolute flex justify-center items-center w-full h-full bg-black z-20 opa rounded-xl overlayOpacity">
    <LockIcon class="text-white w-8 h-8" />
  </div>
</template>

<script>
import LockIcon from './LockIcon.vue';

export default {
  name: 'CreateContentOverlay',
  components: { LockIcon },
};
</script>
<style scoped>
.overlayOpacity {
  opacity: 0.6;
}
</style>
